import React, { useState } from 'react';
import {
  IPlanOverviewDetail,
  ISubjectSubscription,
} from '@models/interfaces/user.interface';
import { Button } from 'geniebook-ui/dist';
import Coin from '@assets/icons/coin';
import moment from 'moment';
import TopUpGenieCredit from '@components/subscription/detail/TopUpGenieCredit';
import { COUNTRY_ID_SINGAPORE } from '@utils/constants/countries.constants';
import { getRenewalDate } from '@components/subscription/helper/SubscriptionHelper';
import { DetailUser } from '@models/types/users.type';
import SimpleBorderedCard from '@components/subscription/detail/micro/SimpleBorderedCard';

export interface SubscriptionDetailCardProps {
  subscription: ISubjectSubscription;
  planDetail: IPlanOverviewDetail;
  userDetail: DetailUser;
}

const SubscriptionDetailCard = ({
  subscription,
  planDetail,
  userDetail,
}: SubscriptionDetailCardProps) => {
  const MYP_PLAN_ID = [
    55, 56, 57, 58, 59, 60, 61, 62, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 100,
    101, 102, 103, 104, 105, 106, 107, 114, 115, 123, 124, 125, 126, 133, 137,
    144, 148,
  ];
  const expiryDate = moment(subscription.expiry_date + '+08:00').format(
    'D MMMM YYYY',
  );
  const renewDate = getRenewalDate(subscription, planDetail).format(
    'D MMM YYYY',
  );
  const [showTopUpCredit, setShowTopUpCredit] = useState(false);

  function handleAddMore() {
    if (planDetail.country_id != COUNTRY_ID_SINGAPORE) {
      window.open('https://geniebook.com/contact', '_blank');
    } else {
      setShowTopUpCredit(true);
    }
  }

  return (
    <>
      <SimpleBorderedCard
        title={
          <>
            <Coin
              className={
                'fill-current text-neutral-chalk w-3.5 inline ml-3 mr-2 align-baseline'
              }
            />
            <p className={'inline text-sm font-bold leading-5'}>
              Worksheet credits
            </p>
          </>
        }
      >
        <div className={'mb-4'}>
          <div className={'mb-4'}>
            <p className={'font-bold text-[34px] leading-[1.2]'}>
              {subscription.genie_credit}
            </p>
            <p className={'font-bold !leading-5 max-lg:text-sm'}>Available</p>
          </div>
          <p
            className={
              'text-neutral-pencil lg:!leading-[19px] lg:text-sm max-lg:!leading-4 max-lg:text-xs'
            }
          >
            {MYP_PLAN_ID.includes(Number(subscription.subscription_plan_id)) ? (
              <span data-testid={'myp-desc'}>
                {subscription.renewal_credit} credits will be added to your
                account annually until {expiryDate}
              </span>
            ) : subscription.is_trial_plan ? (
              <span data-testid={'trial-desc'}>
                Your credits will expire at the end of your trial on{' '}
                {expiryDate}
              </span>
            ) : subscription.auto_renewal ? (
              <span data-testid={'renewal-desc'}>
                {subscription.renewal_credit} credits will automatically be
                added to your account on {renewDate}
              </span>
            ) : (
              <span data-testid={'non-renewal-desc'}>
                Your credits will expire at the end of your subscription on{' '}
                {expiryDate}
              </span>
            )}
          </p>
        </div>
        <div className={'mt-auto'}>
          <Button
            className={
              'w-full !max-w-full !font-extrabold hover:transform hover:!scale-[1.01]'
            }
            onClick={handleAddMore}
          >
            Add more
          </Button>
        </div>
      </SimpleBorderedCard>
      {showTopUpCredit && (
        <TopUpGenieCredit
          onClose={() => setShowTopUpCredit(false)}
          subscription={subscription}
          planDetail={planDetail}
          userDetail={userDetail}
        />
      )}
    </>
  );
};

export default SubscriptionDetailCard;
